interface FlowLoaderProps {
    className?: string;
    message?: string;
}

const FlowLoader = ({ className = "", message }: FlowLoaderProps) => (
    <div className={`flex flex-column ${className}`} style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="flow-loader">
            <div className="flow-loader__bouncer">
                <div className="flow-loader__square" />
            </div>
            <div className="flow-loader__shadow" />
        </div>
        {message && (
            <p style={{ fontSize: "14px", color: "var(--color-text-muted)", marginTop: "-8px" }}>{message}</p>
        )}
    </div>
);

export default FlowLoader;
